import api from '~/api/client';
import { Response } from '@/interfaces/api';
import { StatementResponse, StatementsResponse } from '@/interfaces/statement';
import { CONSUMER_API_PATH } from '@/api/config';

export function getStatements(loanNumber: string, page = 1): Response<StatementsResponse> {
  return api.client.get(`${CONSUMER_API_PATH}/${loanNumber}/consumer_statements/`, {
    params: {
      page
    }
  });
}

export function getStatement(loanNumber: string, statementId: number): Response<StatementResponse> {
  return api.client.get(`${CONSUMER_API_PATH}/${loanNumber}/consumer_statements/${statementId}/`);
}
